<template>
  <div class="event-router">
    <app-link :to="getPath($options.PAGES.ALL_EVENTS)" class="link">
      <geometric-figures-icon/>
      <span>{{ $t('All') }}</span>
    </app-link>
    <app-link :to="getPath($options.PAGES.LIVE)" class="link">
      <stream-icon/>
      <span>{{ $t('Live') }}</span>
    </app-link>
    <app-link :to="getPath($options.PAGES.UPCOMING)" class="link">
      <calendar-with-clock-icon/>
      <span>{{ $t('Upcoming') }}</span>
    </app-link>
    <app-link :to="getPath($options.PAGES.VOD)" class="link">
      <tv-play-icon/>
      <span>{{ $t('OnDemand') }}</span>
    </app-link>
  </div>
</template>

<script>
import AppLink from '../base-components/AppLink';
import {ALL_EVENTS, LIVE, UPCOMING, VOD} from '@/pages';
import StreamIcon from '../../assets/img/StreamIcon';
import CalendarWithClockIcon from '../../assets/img/CalendarWithClockIcon';
import TvPlayIcon from '../../assets/img/tvPlayIcon';
import GeometricFiguresIcon from '@/assets/img/GeometricFiguresIcon';

export default {
  name: 'EventStatusRouter',
  components: {GeometricFiguresIcon, TvPlayIcon, CalendarWithClockIcon, StreamIcon, AppLink},
  PAGES: {
    VOD,
    LIVE,
    UPCOMING,
    ALL_EVENTS,
  },
  methods: {
    getPath({path}) {
      return {
        path,
        query: this.$route.query,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.event-router {
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  align-items: flex-start;
  text-transform: none;
  gap: .2rem;
}

.link {
  display: flex;
  gap: 1rem;
  align-items: center;
  color: var(--settings-body-text-color);
  border-radius: .3rem;
  overflow: hidden;
  padding: .3rem .5rem;
  width: 100%;
  text-decoration: none;

  svg {
    height: 1.5rem;
  }
}

.router-link-active {
  background: var(--settings-body-text-color);
  color: var(--settings-body-main-color);
}
</style>
